import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { ArchivosFormDTO } from '../../../../dto/expediente/archivos-form.dto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { FormField } from '../../../../dto/util/form-field';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { ListaValorService } from '../../sic/proteccion-al-consumidor/services/lista-valor.service';
import { TranslateService } from '@ngx-translate/core';
import { ListasService } from '../../../../services/listas.service';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { TableColumn } from '../../../../dto/util/table-column';
import { TableAction } from '../../../../dto/util/table-action';
import { combineLatest } from 'rxjs';
import { Constants } from '../../../../constants/constants';
import { EntidadFinanciera } from '../../../util/modal-datos/dtos/entidad-financiera-DTO';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';

@Component({
  selector: 'app-sfc-demandado',
  templateUrl: './sfc-demandado.component.html',
  styleUrl: './sfc-demandado.component.scss'
})
export class SfcDemandadoComponent implements OnInit, OnChanges {

  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  archivoPrecargadoPoderJudicial?: AnexoPrecargaResponseDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    archivo?: ArchivosFormDTO | null;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    archivo?: ArchivosFormDTO | null;
  }>();
  @Input() volver: boolean = false;
  @Output() demandadoEmit = new EventEmitter<{
    formDemandado: FormGroup;
  }>();
  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};

  demandantes: PersonaDto[] = [];
  demandados: PersonaDto[] = [];
  apoderados: PersonaDto[] = [];

  columnsDemandado: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableDemandado: PersonaDto[] = [];


  formFieldDemandado: FormField[] = [];

  formTipoPersona!: FormGroup;
  formDemandado!: FormGroup;

  paises: PaisDto[] = [];
  // seteo inputs otro Departamento y municipio
  auxIdCountry: number[] = [];
  dataUsuario!: PersonaLoginDTO;

  private prevTipo: number | null = null;
  private prevIdentificacion: string | null = null;
  indexEditarDemandado: number | undefined = undefined;
  public entidadId: number = Constants.ID_ENTIDAD_SUPERFINANCIERA;

  listadoDemandados: EntidadFinanciera[] = [];
  buildForms() {
    this.formFieldDemandado = [
      {
        name: 'id',
        label: '',
        type: 'text',
        required: false,
        width: '6',
        visible: false,
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['razon-social-required'] },
      },
      {
        name: 'nombreRazonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: false,
        width: '6',
        visible: false,
      },
      {
        name: 'identificacion',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: false,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: false,
        // validation: [Validators.minLength(4)],
        // errorMessages: {
        //   required: this.comunText['numero-documento-required'],
        //   minlength: this.comunText['numero-documento-minlength'],
        // },
      },
      {
        name: 'direccion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        disabled: true,
        // validation: [
        //   Validators.minLength(10),
        //   Validators.maxLength(40),
        //   Validators.pattern(
        //     Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
        //   ),
        // ],
        // maxLength: '40',
        // errorMessages: {
        //   required: this.comunText['direccion-notificacion-judicial-required'],
        //   minlength:
        //     this.comunText['direccion-notificacion-judicial-minlength'],
        //   maxlength:
        //     this.comunText['direccion-notificacion-judicial-maxlength'],
        //   pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        // },
      },
      {
        name: 'representanteLegal',
        label: 'representante legal',
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        disabled: true,
        // validation: [
        //   Validators.minLength(2),
        //   Validators.maxLength(25),
        //   Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        // ],
        // errorMessages: {
        //   required: this.comunText['primer-nombre-required'],
        //   pattern: this.comunText['nombre-pattern'],
        //   minlength: this.comunText['nombre-minlength'],
        //   maxlength: this.comunText['nombre-maxlength'],
        // },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'textarea',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        disabled: true,
        // validation: [
        //   Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        //   Validators.maxLength(100),
        // ],
        // errorMessages: {
        //   required: this.comunText['correo-required'],
        //   pattern: this.comunText['email-pattern'],
        //   maxlength: this.comunText['email-maxlength'],
        // },
      },
    ];
  }

  constructor(
    private fb: FormBuilder,
    private alertaModalService: AlertaModalService,
    private listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService
  ) {
    this.formDemandado = this.fb.group({
    });
    this.getListas();
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
  }

  ngOnInit() {
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
    });
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sfcText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildForms();
      this.iniciarColumnas()
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc'].currentValue;
    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      if (tramite?.demandado !== undefined) {
        for (const demandado of tramite.demandado) {
          if (
            !this.demandados.some(
              dem =>
                dem.idTipoIdentificacion === demandado.idTipoIdentificacion &&
                dem.identificacion === demandado.identificacion
            )
          ) {
            this.demandados.push(demandado);
          }
        }

        this.dataTableDemandado = this.demandados;

        this.iniciarColumnas();
        this.reiniciarFormularios();
      }
    }
  }

  getListas() {
    this.listaServices.getDemandados().subscribe(response => {
      const data = response as EntidadFinanciera[];
      this.formFieldDemandado = this.formFieldDemandado.map(field => {
        if (field.name === 'razonSocial') {
          field.options = data
            .filter(item => item.Abreviatura && item.Abreviatura.trim() !== '')
            .map(item => ({
              Id: item.Id_Entidad_Financiera!,
              Nombre: item.Abreviatura!.toUpperCase(),
            }));
          this.listadoDemandados = data;
        }
        return field;
      });
    });
  }


  private iniciarColumnas() {
    this.columnsDemandado = [
      {
        field: 'primerNombre',
        title: this.comunText['razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  validarFormularioDemandado(formGroup: FormGroup) {
    this.demandadoEmit.emit({
      formDemandado: formGroup,
    });
  }

  onChangeValidarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    const formGroup = $event.form;
    this.formDemandado = formGroup;
    if (formGroup?.get('razonSocial')?.value) {
      this.setearDatosDemandado(formGroup.get('razonSocial')?.value);
    }
  }

  setearDatosDemandado(idDemandado: number) {
    this.listadoDemandados.forEach(elemento => {
      if (elemento.Id_Entidad_Financiera == idDemandado) {
        this.formDemandado.get('identificacion')?.setValue(elemento.Nit);
        this.formDemandado.get('nombreRazonSocial')?.setValue(elemento.Abreviatura?.toUpperCase());
        this.formDemandado.get('direccion')?.setValue(elemento.Direccion);
        this.formDemandado.get('representanteLegal')?.setValue(elemento.Representante_Legal);
        this.formDemandado.get('email')?.setValue(elemento.Correo);
        this.formDemandado.get('id')?.setValue(elemento.Id_Entidad_Financiera);
      }
    })
    this.validarFormularioDemandado(this.formDemandado);
  }

  // Agregar demandado
  agregarDemandado() {
    const representante: PersonaDto = {
      primerNombre: this.formDemandado.get('representanteLegal')?.value
    }
    const demandado: PersonaDto = {
      id: this.formDemandado.get('id')?.value,
      idTipoPersona: 2,
      idTipoIdentificacion: 5,
      identificacion: this.formDemandado.get('identificacion')?.value,
      razonSocial: this.formDemandado.get('razonSocial')?.value,
      primerNombre: this.formDemandado.get('nombreRazonSocial')?.value,
      correoElectronico: this.formDemandado.get('email')?.value,
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandado.get('direccion')?.value,
        },
      ],
      datosRepresentanteLegal: representante
    };

    // Validar contra otros demandantes
    const existeDuplicado = this.esDuplicadoDemandando(demandado);

    // Validar contra apoderado y demandantes
    this.demandantes = JSON.parse(sessionStorage.getItem('demandados')!);
    this.apoderados = JSON.parse(sessionStorage.getItem('apoderados')!);
    const isEmptyDemandado = this.searchInDemandados(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );
    const isEmptyApoderado = this.searchInApoderado(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );

    if (!isEmptyDemandado || !isEmptyApoderado) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['sic-comp-desleal-alertas']['existe']

      );
      return;
    }

    if (existeDuplicado) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['demandado-ya-agregado']
      );
      return;
    }

    // Agregar o editar
    if (this.indexEditarDemandado !== undefined) {
      this.demandados[this.indexEditarDemandado] = demandado;
    } else {
      this.demandados.push(demandado);
    }

    this.dataTableDemandado = this.demandados;
    this.iniciarColumnas();
    this.reiniciarFormularios();
    this.alertaModalService.exito(
      this.alertaText['agregado'],
      this.alertaText['demandante-agregado']
    );
    sessionStorage.setItem('demandados', JSON.stringify(this.demandados));
    this.indexEditarDemandado = undefined;
    this.auxIdCountry = [];
  }

  private esDuplicadoDemandando(demandado: PersonaDto): boolean {
    return this.demandados.some((item, index) => {
      if (this.indexEditarDemandado !== undefined &&
        index === this.indexEditarDemandado) {
        return false;
      }

      return (
        item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
        item.identificacion === demandado.identificacion
      );
    });
  }

  pasarADetalle(e: Event, guardarSinEnviar: boolean) {
    if (this.formDemandado.valid) {
      this.agregarDemandado()
    }
    if (!guardarSinEnviar) {
      if (this.demandados.length === 0) {
        this.formDemandado.markAllAsTouched();
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        return;
      }
    }

    const tramite: TramiteSuperfinancieraDto = {
      id: this.tramiteSfc ? this.tramiteSfc.id : null,
      idTipoTramite: Constants.SFC_PROCON,
      esParcial: true,
      enviar: false,
      demandado: this.demandados,
      usuario: {
        id: this.dataUsuario.idUsuario,
      },
      paso: 3,
    };

    const formValid = this.demandados.length > 0;
    if (!guardarSinEnviar) {
      let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
      if (paso) {
        sessionStorage.setItem(Constants.PASOS, JSON.stringify(4));
      }
      this.continuar.emit({
        tramite: tramite,
        formValid: formValid,
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid: formValid,
        event: e,
      });
    }
  }

  atras() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  borrarDemandado(event: any) {
    this.alertaModalService.confirmacion(
      this.alertaText['sic-procon-alertas']['eliminar-registro'],
      '',
      () => {
        const persona = event.item as PersonaDto;
        this.demandados = this.demandados.filter(item => item !== persona);

        this.dataTableDemandado = this.demandados;


        this.prevTipo = null;
        this.prevIdentificacion = null;
        sessionStorage.setItem('demandados', JSON.stringify(this.demandados));
        this.iniciarColumnas();
      },
      () => { }
    );
  }

  reiniciarFormularios() {
    this.prevTipo = null;
    this.prevIdentificacion = null;

    setTimeout(() => {
      this.formDemandado.reset();
      this.formFieldDemandado = this.formFieldDemandado.map(
        field => {
          if (field.name != 'razonSocial') {
            field.disabled = true;
          } else {
            field.disabled = false;
          }
          return field;
        }
      );
    }, 1);
  }

  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    if (this.demandados) {
      this.demandados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandado']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number
  ): boolean {
    let isEmpty = true;
    if (this.demandantes) {
      this.demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandante']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    if (this.apoderados) {
      this.apoderados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-apoderado']
          );
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  habilitarBtnAgregar(): boolean {
    if (this.formDemandado.get('razonSocial')?.value) {
      return false;
    } else {
      return true;
    }
  }
}

